export default __webpack_public_path__ + "static/media/passaporte_texto_logo.9169f064.svg";